<template>
  <div class="container page" style="background-color: #1f1c1f;">
    <van-nav-bar :title="$t('q58')" class="nav-bar">
      <template #left>
        <img src="/img/newLogin/download.png" @click="back()" style="width: 20px;height: 15px;"/>
      </template>
    </van-nav-bar>
  
    <div class="main">
   
      <van-pull-refresh :pulling-text="$t('loading.refresh')" :loading-text="$t('loading.loading')"  :loosing-text="$t('loading.loss')" :success-text="$t('loading.success')" v-model="isLoading" @refresh="onRefresh">
        <van-empty v-if="rechargeList.length === 0" :description="$t('withdraw.empty_data')" />
        <!-- 充值记录列表 -->
        <div class="item_list" 
            v-else
            v-for="(v, key) in rechargeList" 
            :key="key"
            :class="v.type == 1 ? 'type1' : 'type2'">
          
          <div class="topInfo">
            <span>{{ v.type == 1 ? $t('q62') : $t('q63') }}</span>
            <span class="money">{{$t('q64')}}：{{ v.money }}</span>
          </div>

          <div class="time">
            <span>{{$t('q65')}}：{{ v.create_time }}</span>
          </div>

          <div class="time">
            <span>{{$t('q66')}}：{{ v.desc }}</span>
          </div>
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      rechargeList:[]
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t("reservation.refresh"));
        this.isLoading = false;
      }, 500);
    },
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.$http({
        method: 'get',
        url: 'user_get_recharge_list'
      }).then(res=>{
        this.rechargeList=res.data
      });
    }
  },
  
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
::v-deep .van-pull-refresh__track .van-pull-refresh__head *{
  color: #000000;
  font-size: 35px;
}

::v-deep .van-loading__text {
  color: #000000;
  font-size: 35px;
}
.container .main{
  position: relative;
  overflow: auto;
  background-color: #1f1c1f;
  height: 100%;
  padding: 0 10px;
}
.item_list{
  padding: 15px 15px;
  margin: 30px 10px;
  background: linear-gradient(120deg, #212121, #313131);
  border-radius: 10px;
  line-height: 60px;
  color: #f3c7a2;
  border: 1px solid #766350;
}

.item_list .topInfo span{
  flex: 1;
  font-size: 32px;
  font-weight: 700;
  color: #f3c7a2;
}
.item_list .time span{
  flex: 1;
  font-size: 25px;
  font-weight: 500;
  color: #f3c7a2;
}

.item_list .topInfo span:last-child{

}
.item_list .desc span{
  font-size: 25px;
  font-weight: 700;
  color: #9b9b9b;
}
.item_list .cover{
  width: 60px;
  height: 60px;
  -o-object-fit: cover;
  object-fit: cover;
}
.item_list  .period-number{
  margin-left: 50px;
  margin-right: 10px;
  height: 50px;
  line-height: 60px;
  font-size: 35px;
  font-weight: 700;
  color: #f3c7a2;
}
.item_list .lottery_info{
  display: flex;
}
.recent {
  display: flex;
  align-items: center;
  height: 100px;
}
.kuaisan-ball .left{
  justify-content: flex-start;
}
.kuaisan-ball{
  flex: 1;
  display: flex;
  align-items: center;
}

.kuaisan-ball .res-img{
  width: 70px;
  height: 70px;
  margin-right: 30px;
}
.kuaisan-ball .res-des{
  font-weight: 700;
  text-align: center;
  color: #f3c7a2;
}
.kuaisan-ball .res-des.middle{
  width: 15%;
  font-size: 35px;
}
.ressquareBox{
  background: linear-gradient(90deg, #f560cd, #4f2b8a);
    color: #f3c7a2;
    height: 7vw;
    line-height: 7vw;
    text-align: center;
    font-size: 3vw;
    font-weight: 700;
    border-radius: 16px;
    margin-left: 20px;
    padding:  13px 40px;
    min-width: 13vw;
}
/* 顶部：类型 + 金额 */
.topInfo {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 30px;
  color: #333;
  font-weight: 500;
  margin-bottom: 12px;
}
.money {
  color: #333;
  font-weight: normal;
  text-align: right;
}

/* 时间、说明 */
.time {
  font-size: 26px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 6px;
}

/* 充值高亮 */
.type1 .topInfo span:first-child {
  color: #009688;
}
/* 彩金高亮 */
.type2 .topInfo span:first-child {
  color: #ff7701;
}
</style>
